import { TabIconProps } from '../../interfaces/icons'

const AddIcon = ({ active }: TabIconProps) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.2323 13.4998H19.768M13.5002 7.23193V19.7676"
      stroke={active ? 'white' : 'black'}
      strokeWidth="1.56696"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default AddIcon
